export function getScroller() {
	const isHome = document.body.classList.contains("home");
	const isDesktop = window.innerWidth >= 992;

	return (isHome && isDesktop) ? ".wp-site-blocks" : undefined;
}

export function splitChars(element) {
	const nodes = [...element.childNodes];
	element.innerHTML = "";

	nodes.forEach((node) => {
		if (node.nodeType === Node.TEXT_NODE) {
			appendSplitText(element, node.textContent);
			return;
		}

		if (node.nodeType === Node.ELEMENT_NODE) {
			const clone = node.cloneNode(true);

			splitChars(clone);
			element.appendChild(clone);
		}
	});
}

export function splitWords(element) {
	const nodes = [...element.childNodes];
	element.innerHTML = "";

	nodes.forEach((node) => {
		if (node.nodeType === Node.TEXT_NODE) {
			appendSplitWords(element, node.textContent);
			return;
		}

		if (node.nodeType === Node.ELEMENT_NODE) {
			const clone = node.cloneNode(true);

			splitWords(clone);
			element.appendChild(clone);
		}
	});
}

function appendSplitText(element, text) {
	const words = text.split(/(\s+)/);

	words.forEach((part) => {
		if (part === "") return;

		if (/\s+/.test(part)) {
			element.appendChild(document.createTextNode(part));
			return;
		}

		const wordSpan = document.createElement("span");
		wordSpan.className = "word";

		[...part].forEach((char) => {
			const charSpan = document.createElement("span");
			charSpan.className = "char";
			charSpan.textContent = char;

			wordSpan.appendChild(charSpan);
		});

		element.appendChild(wordSpan);
	});
}

function appendSplitWords(element, text) {
	const words = text.split(/(\s+)/);

	words.forEach((part) => {
		if (part === "") return;

		if (/\s+/.test(part)) {
			element.appendChild(document.createTextNode(part));
			return;
		}

		const wordSpan = document.createElement("span");
		wordSpan.className = "word";
		wordSpan.textContent = part;

		element.appendChild(wordSpan);
	});
}
